<app-header [title]="'Well Connect Surface Equipment'">
</app-header>

<form novalidate [formGroup]="projectModuleFormSE" #wellconnectsurfaceequipment>
  <div class="form-group">

    <div class="bc flex-row">

      <div class="flex-row flex-align-start flex-auto flex-25" style="padding:0 10px 10px 30px">

        <div class="flex-row flex-100" style="border:none;padding-top:20px">
          <kendo-switch formControlName="UseExistingBulkSeparator"
            [onLabel]="''"
            [offLabel]="''"
            (valueChange)="handleSeparators($event)"></kendo-switch>
          <div style="padding:5px 0px 0px 20px">Use Existing Separator</div>
        </div>

        <div class="flex-row flex-100" style="border:none;padding-top:20px">
          <kendo-switch formControlName="IsScada"
            [onLabel]="''"
            [offLabel]="''"></kendo-switch>
          <div style="padding:5px 0px 0px 20px">SCADA</div>
        </div>

        <div class="flex-row flex-100" style="border:none;padding-top:20px">
          <kendo-switch formControlName="IsPower"
            [onLabel]="''"
            [offLabel]="''"></kendo-switch>
          <div style="padding:5px 0px 0px 20px">Power</div>
        </div>
      </div>

      <div class="flex-row flex-align-start flex-auto flex-25" style="padding:0 10px 10px 30px">

        <div class="flex-row flex-100" style="border:none;padding-top:20px">
          <kendo-switch formControlName="IsWellHeadConnect"
            [onLabel]="''"
            [offLabel]="''"></kendo-switch>
          <div style="padding:5px 0px 0px 20px">Well Head Connect</div>
        </div>

        <div class="flex-row flex-100" style="border:none;padding-top:20px">
          <kendo-switch formControlName="TestAllocationOfAllWells"
            [onLabel]="''"
            [offLabel]="''"></kendo-switch>
          <div style="padding:5px 0px 0px 20px">Test Allocation of Wells</div>
        </div>
      </div>

      <div class="flex-row flex-align-start flex-auto flex-25" style="padding:0 10px 10px 30px">

        <div style="width:100%">
          <div class="dp-label">Bulk Separator Size</div>
          <kendo-combobox class="cem-kd-combo form-control" formControlName="BulkSeparatorDiameter"
            [data]="bulkDiameterData"
            [placeholder]="'Select Size...'">
          </kendo-combobox>
        </div>

        @if (shouldDisplaySeparators) {
        <div style="width:100%">
          <div class="dp-label">Quantity of Permanent Separators</div>
          <kendo-numerictextbox formControlName="QuantityOfPermanentSeparators" class="form-control"
            [min]="0"
            [max]="20"
            [step]="1"
            [value]="1"
            [decimals]="decimalPrecision"
            [spinners]="false"
            [format]="decimalFormat">
          </kendo-numerictextbox>
        </div>
        
        <div style="width:100%">
          <div class="dp-label">Quantity of Rental Separators</div>
          <kendo-numerictextbox formControlName="QuantityOfRentalSeparators" class="form-control"
            [min]="0"
            [max]="20"
            [step]="1"
            [value]="1"
            [decimals]="decimalPrecision"
            [spinners]="false"
            [format]="decimalFormat">
          </kendo-numerictextbox>
        </div>
        }

      </div>
      <div class="flex-row flex-align-start flex-auto flex-25" style="padding:0 10px 10px 30px">

        <div style="width:100%">
          <div class="dp-label">Power Line Length (ft)</div>
          <kendo-numerictextbox formControlName="PowerLineLength" class="form-control"
            [min]="0"
            [max]="2000"
            [step]="50"
            [value]="300"
            [decimals]="decimalPrecision"
            [spinners]="false"
            [format]="decimalFormat">
          </kendo-numerictextbox>
        </div>

        <div style="width:100%">
          <div class="dp-label">Inlet Header to Well Length (ft)</div>
          <kendo-numerictextbox formControlName="InletHeadertoWellLength" class="form-control"
            [min]="0"
            [max]="3000"
            [step]="50"
            [value]="100"
            [decimals]="decimalPrecision"
            [spinners]="false"
            [format]="decimalFormat">
          </kendo-numerictextbox>
        </div>

        <div style="padding-top:10px">
          @if (isFormNew && !isProjectModuleReadError && projectModuleFormSE.valid ) {
          <button type="button" kendoButton
            color="primary" (click)="createProjectModule($event)">
            Create
          </button>
          }
          @if (!isFormNew && !isProjectModuleReadError && projectModuleFormSE.dirty ) {
          <button type="button" kendoButton
            color="primary" (click)="updateProjectModule($event)">
            Update
          </button>
          }
        </div>

      </div>
    </div>

  </div>
</form>